/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
import DataSource from '@bingads-webui-component-legacy/double-list-box/service/doubleListBoxDataSource';
var ViewModel = function (options) {
  var self = this;
  self.options = options;
  self.strings = options.strings || ({});
  self.features = options.features || ({});
  self.customData = options.customData || ({});
  self.dataSource = self._createDataSource();
  self.kendoDataSource = self.dataSource.dataSource;
  self.processItem = options.processItem || (function (item) {
    return item || ({});
  });
  self.selectedItem = ko.observable(self.options.data.selectedItem);
  self._initializeFilter();
  self._initializeSourceItemsCount();
  self.refreshSource = _.bind(self.dataSource.refresh, self.dataSource);
};
ViewModel.prototype.setSelectedItem = function (item) {
  var self = this, changed = false, currentId = !!self.selectedItem() ? self.dataSource.getItemId(self.selectedItem()) : null, newId = !!item ? self.dataSource.getItemId(item) : null;
  if (currentId !== newId) {
    self.dataSource.setItemProperty(self.selectedItem(), 'selected', '');
    self.selectedItem(item);
    self.dataSource.setItemProperty(item, 'selected', 'selected');
    changed = true;
  }
  return changed;
};
ViewModel.prototype.refreshItem = function (item) {
  var self = this;
  self.dataSource.refreshItem(item);
};
ViewModel.prototype._initializeFilter = function () {
  var self = this;
  self.filterText = ko.observable('');
  self.filterText.subscribe(function (newValue) {
    self.dataSource.filter(newValue);
  });
};
ViewModel.prototype._initializeSourceItemsCount = function () {
  var self = this, total = self.kendoDataSource.total();
  self.showEmptyMessage = ko.observable(false);
  self.sourceItemsCount = ko.observable(total);
  self.kendoDataSource.bind('change', function () {
    var newTotal = self.kendoDataSource.total();
    self.sourceItemsCount(newTotal);
    newTotal === 0 ? self.showEmptyMessage(true) : self.showEmptyMessage(false);
  });
};
ViewModel.prototype._createDataSource = function () {
  var self = this;
  var sourceCustomActions = [];
  _.each(self.options.itemActions, function (value, key) {
    sourceCustomActions.push({
      name: key,
      caption: value.caption
    });
  });
  return new DataSource({
    dataCallback: _.isFunction(self.options.data.sourceItems) ? self.options.data.sourceItems : null,
    dataItems: !_.isFunction(self.options.data.sourceItems) ? self.options.data.sourceItems : null,
    useCallbackForFetchOnly: self.options.data.useCallbackForFetchOnly,
    itemIdField: self.options.data.itemIdField,
    itemIdCallback: self.options.data.itemIdCallback,
    itemFilterField: self.options.data.itemFilterField,
    itemFilterCallback: self.options.data.itemFilterCallback,
    pageSize: self.features.paging ? self.options.data.pageSize : Math.pow(2, 31),
    listItemSeed: function (item, id) {
      return _.extend(self.processItem(item, id), {
        customActions: sourceCustomActions,
        selected: self.dataSource.getItemId(self.selectedItem()) === id ? 'selected' : '',
        strings: self.strings
      });
    }
  });
};
export default ViewModel;

